<div class="status-chip" [ngClass]="statusInfo.class" role="status" aria-live="polite" tabindex="0">
  <span class="status-text">
    {{ statusInfo.text || 'N/A' }}
  </span>
  <!-- <span *ngIf="statusInfo.svgSafe" [innerHTML]="statusInfo.svgSafe"></span> -->
</div>